import { useApiQuery, CostMetricsRequest } from "@/api";

export type { CostMetricsResponse, MonthlyMetrics } from "@/api";

export function useCostMetrics(startDate: string, endDate: string) {
  const request: CostMetricsRequest = {
    start_date: startDate,
    end_date: endDate,
  };

  return useApiQuery(["get_cost_metrics_timeseries", request], {
    enabled: !!startDate && !!endDate,
  });
}

export function formatMonthLabel(monthStr: string): string {
  const date = new Date(monthStr + "-01T00:00:00");
  return date.toLocaleDateString("en-US", { month: "short" });
}

export function calculateLevel(totalSavings: number): number {
  if (totalSavings >= 200000) return 10;
  if (totalSavings >= 150000) return 9;
  if (totalSavings >= 100000) return 8;
  if (totalSavings >= 75000) return 7;
  if (totalSavings >= 50000) return 6;
  if (totalSavings >= 25000) return 5;
  if (totalSavings >= 10000) return 4;
  if (totalSavings >= 5000) return 3;
  if (totalSavings >= 1000) return 2;
  return 1;
}

export function getNextLevelThreshold(level: number): number {
  const thresholds = [
    0,
    1000,
    5000,
    10000,
    25000,
    50000,
    75000,
    100000,
    150000,
    200000,
    Infinity,
  ];
  return thresholds[level] ?? Infinity;
}

export function calculateLevelProgress(
  totalSavings: number,
  level: number,
): number {
  const thresholds = [
    0, 1000, 5000, 10000, 25000, 50000, 75000, 100000, 150000, 200000,
  ];
  const currentThreshold = thresholds[level - 1] ?? 0;
  const nextThreshold = thresholds[level] ?? totalSavings;

  if (nextThreshold === currentThreshold) return 100;

  const progress =
    ((totalSavings - currentThreshold) / (nextThreshold - currentThreshold)) *
    100;
  return Math.min(Math.max(progress, 0), 100);
}
